//
// MeasureSortContext.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import ClosetObject from "../../../ClosetObject";
import "../../../lib";
import "./SortContext";
import "../hierarchy/Hierarchy";

var MeasureSortContext = createModule("commons::MeasureSortContext", ["commons::SortContext"], ClosetObject, [
    ,
    ,
    ,
    {
        crossingHierarchyPath: [7],
        crossingHierarchy: 1,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default MeasureSortContext;
